import React from 'react';

const EVENT_TYPES = [
  {
    native: 'mousedown',
    react: 'onMouseDown',
  },
  {
    native: 'touchstart',
    react: 'onTouchStart',
  },
];

const useOnClickOutside = (ref, handler) => {
  React.useEffect(() => {
    const listener = event => {
      const elementContainsTarget = element =>
        element.current && element.current.contains(event.target);

      if (Array.isArray(ref)) {
        if (ref.some(elementContainsTarget)) {
          return;
        }
      }

      // Do nothing if clicking ref's element or descendent elements
      if (elementContainsTarget(ref)) {
        return;
      }

      handler(event);
    };

    // Add event listeners for each EVENT_TYPES
    EVENT_TYPES.forEach(({ native }) => {
      document.addEventListener(native, listener);
    });

    return () => {
      // Remove event listeners for each EVENT_TYPES
      EVENT_TYPES.forEach(({ native }) => {
        document.removeEventListener(native, listener);
      });
    };
  }, [ref, handler]);
};

// Create props to help stop firing onClickOutside further up the DOM tree
export const preventPropagationProps = () => {
  return EVENT_TYPES.reduce((acc, { react }) => {
    return {
      ...acc,
      [react]: event => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
      },
    };
  }, {});
};

export default useOnClickOutside;
